import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { ChartDescription } from './LaborMarketSnapshotSection';
import PageLoader from './PageLoader';
import {
  BLS_QCEW_DATA_GUIDE_URL,
  buildIndustryTrendChart,
  findMissingIndustryRuns,
} from './industryTrendChart';
import './IndustryTrendPrototype.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

export { buildIndustryTrendChart, findMissingIndustryRuns };

export default function IndustryTrendPrototype({ loading, error, payload }) {
  if (loading) return <section className="industry-trend"><PageLoader compact label="Loading industry trends" /></section>;
  if (error) return <section className="industry-trend industry-trend--state">{error}</section>;
  if (payload?.status !== 'ready' || !payload?.series?.length) {
    return <section className="industry-trend industry-trend--state">Industry trend history is not available for this market.</section>;
  }
  const chart = buildIndustryTrendChart(payload);
  return (
    <section className="industry-trend" aria-labelledby="industry-trend-title">
      <header className="industry-trend__header">
        <div>
          <span className="industry-trend__eyebrow">Five-year industry trends</span>
          <h2 id="industry-trend-title">Industry Employment Trends</h2>
        </div>
        <span className="industry-trend__period">{payload.latest_period}</span>
      </header>
      <ChartDescription
        question="Are this market’s largest industries growing or shrinking?"
        href={BLS_QCEW_DATA_GUIDE_URL}
        label="BLS QCEW data guide"
      >
        {payload.scope}. Lines rank the five largest sectors in {payload.latest_period}; values are average monthly jobs.
      </ChartDescription>
      <div className="industry-trend__chart">
        <Line data={chart.data} options={chart.options} />
      </div>
    </section>
  );
}
